import { useMutation, type MutationHookOptions } from "@apollo/client"
import mutation from "@/v2-backoffice-client/customer/tenant/remove/many/customer.tenant.remove.many.mutation.gql"
import type {
  CustomerTenantRemoveManyMutation,
  CustomerTenantRemoveManyMutationVariables,
} from "@/v2-backoffice-client/customer/tenant/remove/many/__types__/customer.tenant.remove.many.mutation"

type RemoveOptions = MutationHookOptions<
  CustomerTenantRemoveManyMutation,
  CustomerTenantRemoveManyMutationVariables
>

export function useCustomerTenantRemoveManyMutation(options?: RemoveOptions) {
  return useMutation<
    CustomerTenantRemoveManyMutation,
    CustomerTenantRemoveManyMutationVariables
  >(mutation, options)
}
